import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3181358c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Type", -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Documents joints", -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "nouveau-document"
}
const _hoisted_5 = ["href", "download"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file" }, null, -1 /* HOISTED */))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-rotate-left" }, null, -1 /* HOISTED */))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "nouveau-document"
}
const _hoisted_14 = ["onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    title: "Documents",
    "forced-opened": _ctx.forcedOpened,
    opened: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_2,
            _hoisted_3,
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Nouveau"))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TypesDocument, (typeDocument) => {
            return (_openBlock(), _createElementBlock("tr", { key: typeDocument }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.TypeDocumentString[typeDocument]), 1 /* TEXT */),
              _createElementVNode("td", null, [
                (_ctx.reglement.documents[typeDocument])
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.reglement.documents[typeDocument], (doc) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: _normalizeClass(["file", { 'file-supprime': _ctx.changementsDocuments.supprime.some(sup => sup.id === doc.id) }])
                      }, [
                        _createElementVNode("a", {
                          href: `/api/${_ctx.reglement._id}/fichier/${doc.id}`,
                          download: doc.nom
                        }, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(doc.nom), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_5),
                        (!_ctx.readonly && !_ctx.changementsDocuments.supprime.some(sup => sup.id === doc.id))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn",
                              onClick: ($event: any) => (_ctx.deleteDocument(doc, typeDocument))
                            }, [..._hoisted_9], 8 /* PROPS */, _hoisted_7))
                          : _createCommentVNode("v-if", true),
                        (!_ctx.readonly && _ctx.changementsDocuments.supprime.some(sup => sup.id === doc.id))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn",
                              onClick: ($event: any) => (_ctx.revertDeleteDocument(doc))
                            }, [..._hoisted_12], 8 /* PROPS */, _hoisted_10))
                          : _createCommentVNode("v-if", true)
                      ], 2 /* CLASS */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              (!_ctx.readonly)
                ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    (_openBlock(), _createElementBlock("input", {
                      class: "form-control",
                      type: "file",
                      multiple: "",
                      accept: ".pdf",
                      key: _ctx.reglement.documents[typeDocument] ? _ctx.reglement.documents[typeDocument].map(d => d.id).join(',') : '',
                      onChange: ($event: any) => (_ctx.onFileChange($event as any, typeDocument))
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_14))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["forced-opened"]))
}